import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { applyStoredAccent } from './lib/accent';
import { applyStoredDesign } from './lib/design';
import { QueryProvider } from './lib/QueryProvider';
import { applyStoredTheme } from './lib/theme';
// REV16: loaded before `./index.css` so index.css's token-driven overrides (same-selector,
// same-specificity) win the cascade by source order — see index.css's Toastify section, and
// App.tsx/lib/events.ts (REV18) for why the *component* import has to come from
// `react-toastify/unstyled` for that source-order win to actually stick.
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
// REV30: after index.css on purpose — a design's `:root[data-design]` block has to beat the equally
// specific `:root[data-theme]` blocks by source order (see designs/ledger.css).
import './designs/ledger.css';
import './designs/toybox.css';

// Paint the user's chosen accent and theme before the first render, so a reload never flashes the
// defaults (maple amber / Maple Night) for someone who picked something else on /settings.
applyStoredAccent();
applyStoredTheme();
applyStoredDesign();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found');
}

createRoot(container).render(
  <StrictMode>
    <QueryProvider>
      <App />
    </QueryProvider>
  </StrictMode>,
);
